export enum CollectItemState {
  NOT_COLLECTED = '1',
  COLLECTED = '2'
}

export const Collect_Item_State: { [k: string]: string } = {
  1: 'Not collected',
  2: 'Collected'
};
